import React from 'react';
import clsx from 'clsx';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'subtle';
type Size = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  loading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  iconLeft,
  iconRight,
  loading,
  className,
  disabled,
  children,
  ...rest
}) => (
  <button
    type={rest.type ?? 'button'}
    className={clsx('ui-btn', `ui-btn--${variant}`, `ui-btn--${size}`, loading && 'is-loading', className)}
    disabled={disabled || loading}
    {...rest}
  >
    {iconLeft && <span className="ui-btn__icon">{iconLeft}</span>}
    <span className="ui-btn__label">{children}</span>
    {iconRight && <span className="ui-btn__icon">{iconRight}</span>}
  </button>
);
